export const DISPLAY_MODE_AVATAR_ONLY = 'avatarOnly';
export const DISPLAY_MODE_TEXT_ONLY = 'textOnly';
export const DISPLAY_MODE_AVATAR_AND_TEXT = 'avatarAndText';

export const DIRECTION_LEFT_TO_RIGHT = 'ltr';
export const DIRECTION_RIGHT_TO_LEFT = 'rtl';

export const ARIA_LABEL_MEMBERS_BAR = 'Members bar';

export const TEST_ID_LINK = 'link';
export const TEST_ID_CUSTOM_MENU = 'custom-menu';
export const TEST_ID_ICONS = 'icons';
export const TEST_ID_BADGE = 'badge';
export const TEST_ID_HANDLE_BUTTON = 'handle-button';

export const OPTION_VALUE_LOG_OUT = 'logout';

export const Experiment = {
  EnableLoggingInStateInSSR:
    'specs.thunderbolt.LoginBarEnableLoggingInStateInSSR',
  UseNewElementStructure:
    'specs.thunderbolt.UseNewLoginSocialBarElementStructure',
  UseNestedMenuItems: 'specs.thunderbolt.UseNestedLoginSocialBarMenuItems',
  UseNewLoginBarDropdownMenuAlignment:
    'specs.thunderbolt.UseNewLoginBarDropdownMenuAlignment',
  UseNewLoginBarColorWiringOnE3:
    'specs.thunderbolt.UseNewLoginBarColorWiringOnE3',
} as const;
